(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["authority-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── Helpers ──────────────────────────────────── */
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function isMobile() { return window.innerWidth < 750; }

  /* ── Init all authority-bar auto-scroll sections ── */
  var sections = document.querySelectorAll('[data-authority-auto-scroll="true"]');
  if (!sections.length) return;

  sections.forEach(function (el) {
    var track = el.querySelector('.authority-bar__track');
    if (!track) return;

    var speed       = parseFloat(el.getAttribute('data-auto-scroll-speed')) || 30;
    var doPause     = el.getAttribute('data-auto-scroll-pause') !== 'false';
    var resumeDelay = parseInt(el.getAttribute('data-auto-scroll-resume-delay'), 10) || 2500;

    /* ── Clone management for seamless infinite loop ── */
    var originals    = Array.from(track.children);
    var clones       = [];
    var cloned       = false;
    var contentWidth = 0;

    function cloneOnce(src) {
      var c = src.cloneNode(true);
      c.setAttribute('data-autoscroll-clone', '');
      c.removeAttribute('id');
      Array.from(c.attributes).forEach(function (a) {
        if (a.name.indexOf('data-shopify') === 0) c.removeAttribute(a.name);
      });
      track.appendChild(c);
      clones.push(c);
    }

    function addClones() {
      if (cloned) return;

      /*
       * We need enough cloned copies so that:
       *   track.scrollWidth − track.clientWidth  >=  originalContentWidth
       *
       * Otherwise scrollLeft physically can't reach the loop-reset point
       * because the browser caps it at (scrollWidth − clientWidth).
       *
       * Formula:  copies >= ceil( viewport / origWidth ) + 1
       * The +1 guarantees headroom even if items are narrower than the screen.
       */
      var origWidth = track.scrollWidth;
      var viewWidth = track.clientWidth;
      var copies    = Math.max(2, Math.ceil(viewWidth / Math.max(origWidth, 1)) + 1);

      for (var i = 0; i < copies; i++) {
        originals.forEach(function (child) { cloneOnce(child); });
      }

      cloned = true;
      measure();
    }

    function removeClones() {
      clones.forEach(function (c) { if (c.parentNode) c.parentNode.removeChild(c); });
      clones       = [];
      cloned       = false;
      contentWidth = 0;
    }

    function measure() {
      /*
       * The loop point = the left edge of the FIRST clone.
       * getBoundingClientRect gives us its visual position; adding
       * the current scrollLeft converts it to an absolute scroll offset.
       */
      if (!clones.length) return;
      var trackRect = track.getBoundingClientRect();
      var cloneRect = clones[0].getBoundingClientRect();
      contentWidth  = Math.round(cloneRect.left - trackRect.left + track.scrollLeft);
    }

    /* ── Animation state ─────────────────────────── */
    var paused      = false;
    var resumeTimer = null;
    var lastTs      = null;
    var rafId       = null;
    var running     = false;

    function step(ts) {
      if (!running) return;

      /* Idle when not on mobile or paused */
      if (!isMobile() || paused || reducedMotion.matches) {
        lastTs = null;
        rafId = requestAnimationFrame(step);
        return;
      }

      /* Ensure clones exist */
      if (!cloned) {
        addClones();
        lastTs = null;
        rafId = requestAnimationFrame(step);
        return;
      }

      if (!lastTs) lastTs = ts;
      var dt = (ts - lastTs) / 1000;
      lastTs = ts;

      /* Safety: if measurement failed, retry */
      if (contentWidth <= 0) {
        measure();
        rafId = requestAnimationFrame(step);
        return;
      }

      track.scrollLeft += speed * dt;

      /*
       * Seamless loop: once we scroll past one full set of originals,
       * subtract exactly that distance. Because the cloned content is
       * visually identical, the user sees no jump.
       */
      if (track.scrollLeft >= contentWidth) {
        track.scrollLeft -= contentWidth;
      }

      rafId = requestAnimationFrame(step);
    }

    function start() {
      if (running) return;
      running = true;
      if (isMobile()) addClones();
      rafId = requestAnimationFrame(step);
    }

    function stop() {
      running = false;
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
      lastTs = null;
    }

    /* ── Responsive: add/remove clones on breakpoint change ── */
    function handleResize() {
      if (isMobile()) {
        if (!cloned) addClones();
      } else {
        if (cloned) {
          removeClones();
          track.scrollLeft = 0;
        }
      }
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        handleResize();
        if (cloned) measure();
      }, 120);
    }, { passive: true });

    /* ── Pause / resume on user interaction ──────── */
    if (doPause) {
      var pauseFn = function () {
        paused = true;
        if (resumeTimer) clearTimeout(resumeTimer);
      };
      var resumeFn = function () {
        resumeTimer = setTimeout(function () {
          lastTs = null;   /* Prevent a big delta jump on resume */
          paused = false;
        }, resumeDelay);
      };

      track.addEventListener('touchstart',  pauseFn,  { passive: true });
      track.addEventListener('touchend',    resumeFn, { passive: true });
      track.addEventListener('pointerdown', pauseFn,  { passive: true });
      track.addEventListener('pointerup',   resumeFn, { passive: true });
    }

    /* ── Reduced-motion: start/stop dynamically ──── */
    reducedMotion.addEventListener('change', function (e) {
      if (e.matches) { stop(); removeClones(); track.scrollLeft = 0; }
      else { start(); }
    });

    /* ── Go ──────────────────────────────────────── */
    if (!reducedMotion.matches) start();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["background-video-text"] && !Shopify.designMode) return;
  try {
    
  // Pause native <video> when section is off-screen or tab is hidden — saves battery.
  (function () {
    const init = (root) => {
      if (root.dataset.jygBgvInit === '1') return;
      root.dataset.jygBgvInit = '1';
      const video = root.querySelector('video.jyg-bgv__video');
      if (!video) return;

      let offScreen = false;
      let tabHidden = false;
      const apply = () => {
        if (offScreen || tabHidden) {
          if (!video.paused) video.pause();
        } else if (video.autoplay && video.paused) {
          const p = video.play();
          if (p && typeof p.catch === 'function') p.catch(() => {});
        }
      };

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => { offScreen = !e.isIntersecting; apply(); });
        }, { threshold: 0.1 });
        io.observe(root);
        root._jygBgvIo = io;
      }
      const visHandler = () => { tabHidden = document.hidden; apply(); };
      document.addEventListener('visibilitychange', visHandler);
      root._jygBgvVis = visHandler;
    };

    const initAll = (scope) => {
      (scope || document).querySelectorAll('[data-jyg-bgv]').forEach(init);
    };
    const teardown = (scope) => {
      (scope || document).querySelectorAll('[data-jyg-bgv]').forEach((root) => {
        if (root._jygBgvIo) { root._jygBgvIo.disconnect(); delete root._jygBgvIo; }
        if (root._jygBgvVis) {
          document.removeEventListener('visibilitychange', root._jygBgvVis);
          delete root._jygBgvVis;
        }
        delete root.dataset.jygBgvInit;
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load',   (e) => initAll(e.target));
    document.addEventListener('shopify:section:unload', (e) => teardown(e.target));
    document.addEventListener('shopify:section:select', (e) => initAll(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jyg-article-gear"] && !Shopify.designMode) return;
  try {
    
(function () {
  function openAll() {
    var cards = document.getElementById('jyg-cards');
    if (cards) cards.classList.add('open');
    var btn = document.getElementById('jyg-more');
    if (btn) btn.remove();
  }
  var more = document.getElementById('jyg-more');
  if (more) more.addEventListener('click', openAll);

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-p]');
    if (!link) return;
    var card = document.getElementById(link.getAttribute('data-p'));
    if (!card) return;
    if (card.classList.contains('more')) openAll();
    document.querySelectorAll('.pc.hit').forEach(function (el) { el.classList.remove('hit'); });
    setTimeout(function () {
      card.classList.add('hit');
      setTimeout(function () { card.classList.remove('hit'); }, 2000);
    }, 400);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jyg-background-video"] && !Shopify.designMode) return;
  try {
    
  // Pause native <video> when section is off-screen or tab is hidden — saves battery.
  (function () {
    const init = (root) => {
      if (root.dataset.jygBgvInit === '1') return;
      root.dataset.jygBgvInit = '1';
      const videos = Array.prototype.slice.call(
        root.querySelectorAll('video.jyg-bgv__video')
      );
      if (!videos.length) return;

      let offScreen = false;
      let tabHidden = false;
      // Only the clip the breakpoint actually shows is loaded and played, so a
      // desktop/mobile pair never downloads both files.
      const isVisible = (v) => v.getClientRects().length > 0;
      const apply = () => {
        videos.forEach((v) => {
          const wanted = v.dataset.bgvAutoplay === 'true';
          if (!isVisible(v) || offScreen || tabHidden) {
            if (!v.paused) v.pause();
            return;
          }
          if (!wanted) return;
          if (v.preload === 'none' && v.networkState === 0) {
            v.preload = 'auto';
            v.load();
          }
          if (v.paused) {
            const p = v.play();
            if (p && typeof p.catch === 'function') p.catch(() => {});
          }
        });
      };
      window.addEventListener('resize', apply);

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => { offScreen = !e.isIntersecting; apply(); });
        }, { threshold: 0.1 });
        io.observe(root);
        root._jygBgvIo = io;
      }
      const visHandler = () => { tabHidden = document.hidden; apply(); };
      document.addEventListener('visibilitychange', visHandler);
      root._jygBgvVis = visHandler;
    };

    const initAll = (scope) => {
      (scope || document).querySelectorAll('[data-jyg-bgv]').forEach(init);
    };
    const teardown = (scope) => {
      (scope || document).querySelectorAll('[data-jyg-bgv]').forEach((root) => {
        if (root._jygBgvIo) { root._jygBgvIo.disconnect(); delete root._jygBgvIo; }
        if (root._jygBgvVis) {
          document.removeEventListener('visibilitychange', root._jygBgvVis);
          delete root._jygBgvVis;
        }
        delete root.dataset.jygBgvInit;
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load',   (e) => initAll(e.target));
    document.addEventListener('shopify:section:unload', (e) => teardown(e.target));
    document.addEventListener('shopify:section:select', (e) => initAll(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jyg-footer-pro"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fit(root) {
      var boxes = (root || document).querySelectorAll('[data-jygfp-bleed]');
      Array.prototype.forEach.call(boxes, function (box) {
        var span = box.querySelector('[data-jygfp-wm]');
        if (!span) return;
        var avail = box.clientWidth;
        if (!avail) return;
        var scale = parseFloat(box.getAttribute('data-scale') || '100') / 100;
        var maxw = parseFloat(box.getAttribute('data-maxw') || '0');
        if (maxw > 0 && maxw < avail) avail = maxw;
        var target = avail * scale;
        span.style.fontSize = '';
        box.style.fontSize = '100px';
        var w = span.scrollWidth;
        if (!w) { box.style.fontSize = ''; return; }
        var fs = 100 * (target / w);
        box.style.fontSize = fs + 'px';
        for (var i = 0; i < 3; i++) {
          var got = span.scrollWidth;
          if (!got || Math.abs(got - target) <= 1) break;
          fs = fs * (target / got);
          box.style.fontSize = fs + 'px';
        }
      });
    }
    function boot(root) {
      var nodes = (root || document).querySelectorAll('[data-jygfp]');
      Array.prototype.forEach.call(nodes, function (el) {
        if (el.jygfpReady) return;
        el.jygfpReady = true;
      });
      fit(root);
      klaviyoBoot(root);
    }

    /* ---- Klaviyo bridge ----
       The Shopify customer form still posts normally. We fire an extra
       subscription to Klaviyo with keepalive so it survives the navigation.
       Endpoint: POST /client/subscriptions, public company_id only, no auth
       header. CORS only allows content-type and revision headers. */
    var KL_REVISION = '2026-07-15';

    function readCompanyId(cb) {
      var tries = 0;
      (function poll() {
        tries++;
        var k = window.klaviyo;
        if (k && typeof k.account === 'function') {
          try {
            var r = k.account();
            if (r && typeof r.then === 'function') {
              r.then(function (id) { if (id) cb(String(id)); }, function () {});
              return;
            }
            if (r) { cb(String(r)); return; }
          } catch (e) {}
        }
        if (tries < 20) window.setTimeout(poll, 500);
      })();
    }

    function klaviyoBoot(root) {
      var wraps = (root || document).querySelectorAll('[data-jygfp-klaviyo]');
      Array.prototype.forEach.call(wraps, function (wrap) {
        if (wrap.jygfpKlReady) return;
        wrap.jygfpKlReady = true;

        var listId = wrap.getAttribute('data-kl-list');
        if (!listId) return;
        var source = wrap.getAttribute('data-kl-source') || 'Footer signup';
        var company = wrap.getAttribute('data-kl-company') || '';
        if (!company) { readCompanyId(function (id) { company = id; }); }

        var form = wrap.closest ? wrap.closest('form') : null;
        if (!form) return;

        form.addEventListener('submit', function () {
          var input = wrap.querySelector('input[type="email"]');
          var email = input && input.value ? input.value.trim() : '';
          if (!email || !company) return;
          try {
            fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
              method: 'POST',
              keepalive: true,
              headers: { 'content-type': 'application/vnd.api+json', 'revision': KL_REVISION },
              body: JSON.stringify({
                data: {
                  type: 'subscription',
                  attributes: {
                    custom_source: source,
                    profile: {
                      data: {
                        type: 'profile',
                        attributes: {
                          email: email,
                          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                        }
                      }
                    }
                  },
                  relationships: { list: { data: { type: 'list', id: listId } } }
                }
              })
            });
          } catch (e) {}
        });
      });
    }

    var t;
    function onResize() { clearTimeout(t); t = setTimeout(function () { fit(document); }, 120); }
    function settle() {
      [120, 400, 900, 2000].forEach(function (ms) {
        window.setTimeout(function () { fit(document); }, ms);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(document); settle(); });
    } else { boot(document); settle(); }
    window.addEventListener('load', function () { fit(document); });
    window.addEventListener('resize', onResize);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { fit(document); window.setTimeout(function () { fit(document); }, 120); });
    }
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { clearTimeout(t); t = setTimeout(function () { fit(document); }, 90); });
      Array.prototype.forEach.call(document.querySelectorAll('[data-jygfp-bleed]'), function (b) { ro.observe(b); });
    }
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); settle(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jyg-hook-table"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-jyg-hooktable]');

    roots.forEach(function (root) {
      var table = root.querySelector('[data-jyg-table]');
      if (!table) return;
      root.classList.add('jyg-hooktable--js');

      var tbody = table.querySelector('tbody');
      var rows = Array.prototype.slice.call(tbody.querySelectorAll('tr'));
      var originalOrder = rows.slice();
      var pills = Array.prototype.slice.call(root.querySelectorAll('[data-jyg-pills] .jyg-hooktable__pill'));
      var countEl = root.querySelector('[data-jyg-count]');
      var scrollEl = root.querySelector('[data-jyg-scroll]');
      var scrollWrapper = root.querySelector('.jyg-hooktable__scroll-wrapper');
      var ths = table.querySelectorAll('th[data-sort-type]');
      var emptyText = root.dataset.emptyText || '—';

      var HOOK_LABEL = { twin: 'Twin Assist', single: 'Single Assist', tuna: 'Tuna Assist', squid: 'Squid Assist' };

      function renderSizes(raw) {
        if (!raw) return emptyText;
        var parts = raw.split(' ');
        if (table.dataset.badge === 'true') {
          return parts.map(function (p) { return '<span class="jyg-hooktable__badge">' + p + '</span>'; }).join('');
        }
        return parts.join(' · ');
      }

      function setFilter(type, value) {
        table.dataset.filter = type;
        if (type === 'hook') table.dataset.hook = value;

        var visible = 0;
        rows.forEach(function (tr) {
          var show = true;
          if (type === 'jig') show = tr.dataset.jig === value;
          else if (type === 'hook') show = (tr.dataset[value] || '') !== '';
          tr.hidden = !show;
          if (show) visible++;
          if (type === 'hook') {
            var cell = tr.querySelector('[data-col="size"]');
            if (cell) cell.innerHTML = renderSizes(tr.dataset[value] || '');
          }
        });

        var sizeTh = table.querySelector('th[data-col="size"]');
        if (sizeTh) sizeTh.textContent = (type === 'hook') ? ((HOOK_LABEL[value] || 'Size') + ' size') : 'Size';

        pills.forEach(function (p) {
          var active = (p.dataset.filterType === type) && ((type === 'all') || (p.dataset.filterValue === value));
          p.classList.toggle('is-active', active);
          p.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        if (countEl) {
          var noun = type === 'hook' ? 'jigs' : 'rows';
          countEl.textContent = visible + ' ' + noun;
        }
        updateScrollState();
      }

      pills.forEach(function (p) {
        p.addEventListener('click', function () {
          setFilter(p.dataset.filterType, p.dataset.filterValue);
        });
      });

      function parseVal(raw, t) {
        if (raw == null) return '';
        var s = String(raw).trim();
        if (s === '' || s === emptyText) return t === 'text' ? '' : -Infinity;
        if (t === 'weight') { var m = s.match(/[\d.]+/); return m ? parseFloat(m[0]) : 0; }
        return s.toLowerCase();
      }
      function sortBy(th) {
        var t = th.dataset.sortType;
        var idx = Array.prototype.indexOf.call(th.parentNode.children, th);
        var cur = th.dataset.sortState;
        var next = cur === 'none' ? 'asc' : (cur === 'asc' ? 'desc' : 'none');
        ths.forEach(function (o) { if (o !== th) { o.dataset.sortState = 'none'; o.setAttribute('aria-sort', 'none'); } });
        th.dataset.sortState = next;
        th.setAttribute('aria-sort', next === 'asc' ? 'ascending' : next === 'desc' ? 'descending' : 'none');
        if (next === 'none') { originalOrder.forEach(function (r) { tbody.appendChild(r); }); return; }
        var arr = rows.slice();
        arr.sort(function (a, b) {
          var ac = a.children[idx], bc = b.children[idx];
          var av = parseVal(ac ? (ac.dataset.sortValue || ac.textContent) : '', t);
          var bv = parseVal(bc ? (bc.dataset.sortValue || bc.textContent) : '', t);
          var cmp = (typeof av === 'number' && typeof bv === 'number') ? av - bv : String(av).localeCompare(String(bv));
          return next === 'asc' ? cmp : -cmp;
        });
        arr.forEach(function (r) { tbody.appendChild(r); });
      }
      ths.forEach(function (th) {
        th.addEventListener('click', function () { sortBy(th); });
        th.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); sortBy(th); } });
      });

      var mqMobile = window.matchMedia('(max-width: 749px)');
      function toggleRow(tr) {
        var open = tr.classList.toggle('is-open');
        tr.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      function applyRowA11y() {
        var on = mqMobile.matches;
        rows.forEach(function (tr) {
          if (on) {
            tr.setAttribute('role', 'button');
            tr.setAttribute('tabindex', '0');
            if (!tr.hasAttribute('aria-expanded')) tr.setAttribute('aria-expanded', 'false');
          } else {
            tr.removeAttribute('role');
            tr.removeAttribute('tabindex');
            tr.removeAttribute('aria-expanded');
            tr.classList.remove('is-open');
          }
        });
      }
      rows.forEach(function (tr) {
        tr.addEventListener('click', function (e) {
          if (!mqMobile.matches) return;
          if (e.target.closest('a')) return;
          toggleRow(tr);
        });
        tr.addEventListener('keydown', function (e) {
          if (!mqMobile.matches) return;
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleRow(tr); }
        });
      });
      applyRowA11y();
      if (mqMobile.addEventListener) mqMobile.addEventListener('change', applyRowA11y);
      else if (mqMobile.addListener) mqMobile.addListener(applyRowA11y);

      function updateScrollState() {
        if (!scrollEl || !scrollWrapper) return;
        var overflow = scrollEl.scrollWidth > scrollEl.clientWidth + 1;
        var atEnd = scrollEl.scrollLeft + scrollEl.clientWidth >= scrollEl.scrollWidth - 1;
        scrollWrapper.classList.toggle('is-scrollable', overflow);
        scrollWrapper.classList.toggle('is-scrolled-end', atEnd);
      }
      if (scrollEl) {
        scrollEl.addEventListener('scroll', updateScrollState, { passive: true });
        window.addEventListener('resize', updateScrollState);
      }

      setFilter(root.dataset.initType || 'all', root.dataset.initValue || '');
    });
  })();

  (function () {
    document.querySelectorAll('[data-jyg-jigtabs]').forEach(function (root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-jigtab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-jigpanel]'));
      function activate(m) {
        tabs.forEach(function (t) {
          var on = t.dataset.jigtab === m;
          t.classList.toggle('is-on', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var on = p.dataset.jigpanel === m;
          p.classList.toggle('is-on', on);
          if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
        });
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () { activate(t.dataset.jigtab); });
        t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(t.dataset.jigtab); } });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jyg-kits"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot(root) {
      var nodes = (root || document).querySelectorAll('[data-jyg-kits]');
      Array.prototype.forEach.call(nodes, function (el) {
        if (el.jygKitsReady) return;
        el.jygKitsReady = true;

        var tabs = el.querySelectorAll('[data-jk-tab]');
        var panels = el.querySelectorAll('[data-jk-panel]');
        var strip = el.querySelector('[data-jk-tabs]');
        var wrap = el.querySelector('[data-jk-tabwrap]');
        var prev = el.querySelector('[data-jk-prev]');
        var next = el.querySelector('[data-jk-next]');

        function show(key) {
          Array.prototype.forEach.call(panels, function (p) {
            p.hidden = p.getAttribute('data-jk-panel') !== key;
          });
          Array.prototype.forEach.call(tabs, function (t) {
            t.setAttribute('aria-selected', t.getAttribute('data-jk-tab') === key ? 'true' : 'false');
          });
        }

        Array.prototype.forEach.call(tabs, function (t) {
          t.addEventListener('click', function () {
            show(t.getAttribute('data-jk-tab'));
            if (t.scrollIntoView) {
              t.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
            }
          });
        });

        if (panels.length) {
          var firstKey = panels[0].getAttribute('data-jk-panel');
          show(firstKey);
        }

        function syncArrows() {
          if (!strip || !wrap) return;
          var max = strip.scrollWidth - strip.clientWidth;
          var atStart = strip.scrollLeft <= 4;
          var atEnd = strip.scrollLeft >= max - 4;
          wrap.classList.toggle('at-start', atStart);
          wrap.classList.toggle('at-end', atEnd || max <= 4);
          if (prev) prev.hidden = atStart || max <= 4;
          if (next) next.hidden = atEnd || max <= 4;
        }
        if (strip) {
          strip.addEventListener('scroll', syncArrows);
          window.addEventListener('resize', syncArrows);
          if (prev) prev.addEventListener('click', function () { strip.scrollBy({ left: -180, behavior: 'smooth' }); });
          if (next) next.addEventListener('click', function () { strip.scrollBy({ left: 180, behavior: 'smooth' }); });
          syncArrows();
        }

        var single = el.getAttribute('data-open-mode') === 'single';
        el.addEventListener('click', function (e) {
          var head = e.target.closest ? e.target.closest('[data-jk-toggle]') : null;
          if (!head || !el.contains(head)) return;
          var card = head.parentNode;
          var opening = !card.classList.contains('is-open');
          if (single && opening) {
            var panel = card.parentNode;
            Array.prototype.forEach.call(panel.querySelectorAll('.jyg-kits__card'), function (c) {
              c.classList.remove('is-open');
              var h = c.querySelector('[data-jk-toggle]');
              if (h) h.setAttribute('aria-expanded', 'false');
            });
          }
          card.classList.toggle('is-open', opening);
          head.setAttribute('aria-expanded', opening ? 'true' : 'false');
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(document); });
    } else {
      boot(document);
    }
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jyg-nav"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const nav = document.querySelector('.jyg-nav-{{ section.id }}');
    if (!nav) return;

    const burger = nav.querySelector('[data-nav-toggle]');
    const links = nav.querySelectorAll('.jyg-nav__links a');

    const setOpen = (open) => {
      nav.classList.toggle('jyg-nav--open', open);
      burger?.setAttribute('aria-expanded', String(open));
    };

    burger?.addEventListener('click', () => {
      const isOpen = nav.classList.contains('jyg-nav--open');
      setOpen(!isOpen);
    });

    links.forEach((link) => {
      link.addEventListener('click', () => setOpen(false));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setOpen(false);
    });

    document.addEventListener('click', (event) => {
      if (!nav.contains(event.target)) setOpen(false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jyg-outlet-grid"] && !Shopify.designMode) return;
  try {
    
(function() {
  var MOBILE_BREAKPOINT = 749;
  var EDGE_THRESHOLD = 4; // px from edge to trigger teleport
  var PREFERS_REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function isMobile() {
    return window.matchMedia('(max-width: ' + MOBILE_BREAKPOINT + 'px)').matches;
  }

  function initSection(section) {
    var grid = section.querySelector('[data-outlet-grid]');
    var prev = section.querySelector('[data-outlet-prev]');
    var next = section.querySelector('[data-outlet-next]');
    if (!grid || !prev || !next) return;

    var originalCards = Array.prototype.slice.call(grid.querySelectorAll('[data-outlet-card]'));
    if (originalCards.length === 0) return;

    var state = {
      loopActive: false,
      isAdjusting: false
    };

    function getStep() {
      var card = grid.querySelector('[data-outlet-card]');
      if (!card) return 0;
      var cardWidth = card.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(grid).gap) || 0;
      return cardWidth + gap;
    }

    function enableLoop() {
      if (state.loopActive) return;

      // Clone all original cards before and after the originals → 3 sets in DOM.
      // Clones get aria-hidden + tabindex=-1 so screen readers / keyboard skip them.
      function makeClone(card) {
        var clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        clone.setAttribute('data-clone', 'true');
        // Keep focusable children (e.g. variant swatches) out of the tab order.
        var focusable = clone.querySelectorAll('[role="link"], [tabindex]');
        for (var i = 0; i < focusable.length; i++) focusable[i].setAttribute('tabindex', '-1');
        return clone;
      }
      originalCards.forEach(function(card) {
        grid.appendChild(makeClone(card));
      });
      originalCards.slice().reverse().forEach(function(card) {
        grid.insertBefore(makeClone(card), grid.firstChild);
      });

      state.loopActive = true;

      // Jump scroll to the middle (the original set) without animation.
      requestAnimationFrame(function() {
        state.isAdjusting = true;
        var step = getStep();
        grid.scrollLeft = step * originalCards.length;
        // Let the browser settle, then re-enable the scroll listener
        setTimeout(function() { state.isAdjusting = false; }, 50);
      });
    }

    function disableLoop() {
      if (!state.loopActive) return;
      // Remove all clones
      grid.querySelectorAll('[data-clone]').forEach(function(el) {
        el.parentNode.removeChild(el);
      });
      state.loopActive = false;
      grid.scrollLeft = 0;
    }

    function teleportIfNeeded() {
      if (!state.loopActive || state.isAdjusting) return;

      var step = getStep();
      if (step === 0) return;

      var setWidth = step * originalCards.length;
      var current = grid.scrollLeft;

      // If we've scrolled into the trailing clone set → jump back to the middle set
      if (current >= setWidth * 2 - EDGE_THRESHOLD) {
        state.isAdjusting = true;
        grid.style.scrollBehavior = 'auto';
        grid.scrollLeft = current - setWidth;
        // Restore smooth and release the lock
        requestAnimationFrame(function() {
          grid.style.scrollBehavior = '';
          state.isAdjusting = false;
        });
      }
      // If we've scrolled into the leading clone set → jump forward to the middle set
      else if (current <= EDGE_THRESHOLD) {
        state.isAdjusting = true;
        grid.style.scrollBehavior = 'auto';
        grid.scrollLeft = current + setWidth;
        requestAnimationFrame(function() {
          grid.style.scrollBehavior = '';
          state.isAdjusting = false;
        });
      }
    }

    function scrollByCard(direction) {
      var step = getStep();
      if (!step) return;
      grid.scrollBy({ left: step * direction, behavior: PREFERS_REDUCED_MOTION ? 'auto' : 'smooth' });
    }

    function updateArrows() {
      if (state.loopActive) {
        // In infinite mode, arrows are always enabled — never reach an "end"
        prev.removeAttribute('disabled');
        next.removeAttribute('disabled');
        return;
      }
      var maxScroll = grid.scrollWidth - grid.clientWidth;
      var current = grid.scrollLeft;
      prev.toggleAttribute('disabled', current <= EDGE_THRESHOLD);
      next.toggleAttribute('disabled', current >= maxScroll - EDGE_THRESHOLD);
    }

    function handleScroll() {
      teleportIfNeeded();
      updateArrows();
    }

    function currentLayout() {
      // Pick the layout that applies to the current viewport.
      if (isMobile()) {
        return section.getAttribute('data-mobile-layout') || 'carousel';
      }
      return section.getAttribute('data-desktop-layout') || 'grid';
    }

    function syncMode() {
      // Infinite-loop carousel runs whenever the ACTIVE layout (desktop or
      // mobile, depending on viewport) is "carousel". Otherwise clones are removed.
      if (currentLayout() === 'carousel') {
        enableLoop();
      } else {
        disableLoop();
      }
      updateArrows();
    }

    prev.addEventListener('click', function() { scrollByCard(-1); });
    next.addEventListener('click', function() { scrollByCard(1); });
    grid.addEventListener('scroll', handleScroll, { passive: true });

    // Debounced resize handler to switch between mobile/desktop modes
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(syncMode, 150);
    });

    syncMode();
  }

  // ─── Variant swatches: hover-preview image/price + click-through to variant ───
  function initVariants(section) {
    var grid = section.querySelector('[data-outlet-grid]');
    if (!grid) return;
    if (!grid.querySelector('[data-outlet-variants]')) return;

    var hoverSwap = section.getAttribute('data-variant-hover-swap') === 'true';
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    // Track touch movement so a carousel swipe that starts on a swatch
    // doesn't accidentally navigate to that variant.
    var touchMoved = false;
    var touchStartX = 0, touchStartY = 0;
    grid.addEventListener('touchstart', function(e) {
      touchMoved = false;
      if (e.touches && e.touches[0]) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }
    }, { passive: true });
    grid.addEventListener('touchmove', function(e) {
      if (!e.touches || !e.touches[0]) return;
      var dx = Math.abs(e.touches[0].clientX - touchStartX);
      var dy = Math.abs(e.touches[0].clientY - touchStartY);
      if (dx > 8 || dy > 8) touchMoved = true;
    }, { passive: true });

    function applyVariant(sw) {
      var card = sw.closest('[data-outlet-card]');
      if (!card) return;
      var img = card.querySelector('.jyg-outlet__img--primary');
      var media = card.querySelector('.jyg-outlet__media');
      var price = card.querySelector('[data-outlet-price]');
      var compare = card.querySelector('[data-outlet-compare]');

      var vimg = sw.getAttribute('data-variant-img');
      if (img && vimg) {
        if (!img.hasAttribute('data-orig-src')) {
          img.setAttribute('data-orig-src', img.getAttribute('src') || '');
          img.setAttribute('data-orig-srcset', img.getAttribute('srcset') || '');
        }
        img.setAttribute('srcset', '');
        img.src = vimg;
        if (media) media.setAttribute('data-variant-active', '');
      }
      if (price) {
        var p = sw.getAttribute('data-variant-price');
        if (p) price.textContent = p;
      }
      if (compare) {
        var c = sw.getAttribute('data-variant-compare');
        if (c) { compare.textContent = c; compare.hidden = false; }
        else { compare.hidden = true; }
      }
      var siblings = card.querySelectorAll('.jyg-outlet__swatch');
      for (var i = 0; i < siblings.length; i++) siblings[i].classList.remove('is-active');
      sw.classList.add('is-active');
    }

    function restoreCard(card) {
      if (!card) return;
      var img = card.querySelector('.jyg-outlet__img--primary');
      var media = card.querySelector('.jyg-outlet__media');
      var price = card.querySelector('[data-outlet-price]');
      var compare = card.querySelector('[data-outlet-compare]');
      var box = card.querySelector('[data-outlet-variants]');

      if (img && img.hasAttribute('data-orig-src')) {
        img.src = img.getAttribute('data-orig-src');
        var os = img.getAttribute('data-orig-srcset');
        if (os) img.setAttribute('srcset', os); else img.removeAttribute('srcset');
      }
      if (media) media.removeAttribute('data-variant-active');
      if (box && price) {
        var dp = box.getAttribute('data-default-price');
        if (dp) price.textContent = dp;
      }
      if (box && compare) {
        var dc = box.getAttribute('data-default-compare');
        if (dc) { compare.textContent = dc; compare.hidden = false; }
        else { compare.hidden = true; }
      }
      var swatches = card.querySelectorAll('.jyg-outlet__swatch');
      for (var i = 0; i < swatches.length; i++) swatches[i].classList.remove('is-active');
    }

    function navigate(sw) {
      var url = sw.getAttribute('data-variant-url');
      if (url) window.location.href = url;
    }

    // Delegated so dynamically cloned mobile cards are covered too.
    if (hoverSwap && canHover) {
      grid.addEventListener('mouseover', function(e) {
        var sw = e.target.closest('.jyg-outlet__swatch[data-variant-url]');
        if (sw) applyVariant(sw);
      });
      grid.addEventListener('mouseout', function(e) {
        var card = e.target.closest('[data-outlet-card]');
        if (!card) return;
        var to = e.relatedTarget;
        if (!to || !card.contains(to)) restoreCard(card);
      });
    }

    grid.addEventListener('click', function(e) {
      var sw = e.target.closest('.jyg-outlet__swatch[data-variant-url]');
      if (!sw) return;
      e.preventDefault();
      e.stopPropagation();
      // Ignore the click if it came from a swipe gesture, not a deliberate tap.
      if (touchMoved) { touchMoved = false; return; }
      navigate(sw);
    });

    grid.addEventListener('keydown', function(e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var sw = e.target.closest('.jyg-outlet__swatch[data-variant-url]');
      if (!sw) return;
      e.preventDefault();
      navigate(sw);
    });
  }

  function boot(root) {
    var scope = (root && root.querySelectorAll) ? root : document;
    scope.querySelectorAll('.jyg-outlet').forEach(function(section) {
      if (section.__jygOutletInit) return; // guard against double init
      section.__jygOutletInit = true;
      initSection(section);
      initVariants(section);
    });
  }

  boot(document);

  // Re-initialise when the section is added/re-rendered in the Theme Editor.
  document.addEventListener('shopify:section:load', function(e) {
    boot(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jyg-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.querySelectorAll('.jyg-pc').forEach(function (card) {
    var variantsEl   = card.querySelector('.jyg-pc__variants-json');
    var atcBtn       = card.querySelector('.jyg-pc__atc');
    var optionGroups = card.querySelectorAll('.jyg-pc__opt-group');

    /* ── Variant matching (only when product has multiple variants) ── */
    if (variantsEl && atcBtn && optionGroups.length) {
      var variants = JSON.parse(variantsEl.textContent.trim());

      function getSelectedOptions() {
        var sel = [];
        optionGroups.forEach(function (g) {
          var active = g.querySelector('.jyg-pc__opt-btn.is-active');
          sel.push(active ? active.dataset.value : null);
        });
        return sel;
      }

      function findVariant(selected) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === selected[i]; });
        }) || null;
      }

      function syncAtc() {
        var variant = findVariant(getSelectedOptions());
        if (variant) {
          atcBtn.dataset.variantId = variant.id;
          atcBtn.disabled          = !variant.available;
          atcBtn.textContent       = variant.available
            ? atcBtn.dataset.labelAtc
            : atcBtn.dataset.labelSold;
        } else {
          atcBtn.disabled    = true;
          atcBtn.textContent = atcBtn.dataset.labelAtc;
        }
      }

      optionGroups.forEach(function (group) {
        group.querySelectorAll('.jyg-pc__opt-btn').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            group.querySelectorAll('.jyg-pc__opt-btn').forEach(function (b) {
              b.classList.remove('is-active');
            });
            btn.classList.add('is-active');
            syncAtc();
          });
        });
      });

      syncAtc(); /* init state */
    }

    /* ── Add to Cart fetch ── */
    if (atcBtn) {
      atcBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (atcBtn.disabled) return;

        var variantId    = atcBtn.dataset.variantId;
        var originalText = atcBtn.textContent.trim();
        atcBtn.disabled  = true;

        fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            atcBtn.textContent = 'Added \u2713';
            setTimeout(function () {
              atcBtn.textContent = originalText;
              atcBtn.disabled    = false;
            }, 1500);
          })
          .catch(function () {
            atcBtn.disabled = false;
          });
      });
    }
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jyg-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.rvcReady === '1') return;
      root.dataset.rvcReady = '1';

      var track = root.querySelector('[data-rvc-track]');
      if (!track) return;
      var prev = root.querySelector('[data-rvc-prev]');
      var next = root.querySelector('[data-rvc-next]');

      function step() {
        var item = track.querySelector('.jyg-rvc__item');
        if (!item) return track.clientWidth;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return item.getBoundingClientRect().width + gap;
      }

      function maxScroll() {
        return Math.max(0, track.scrollWidth - track.clientWidth);
      }

      function go(dir) {
        var max = maxScroll();
        if (max <= 1) return;
        var target = track.scrollLeft + dir * step();
        // Wrap around so the carousel behaves like a loop.
        if (dir > 0 && track.scrollLeft >= max - 2) target = 0;
        if (dir < 0 && track.scrollLeft <= 2) target = max;
        track.scrollTo({ left: target, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { go(-1); pause(); });
      if (next) next.addEventListener('click', function () { go(1); pause(); });

      // Hide arrows when everything already fits.
      function syncArrows() {
        var fits = maxScroll() <= 1;
        if (prev) prev.hidden = fits;
        if (next) next.hidden = fits;
      }
      syncArrows();
      if (window.ResizeObserver) {
        new ResizeObserver(syncArrows).observe(track);
      } else {
        window.addEventListener('resize', syncArrows);
      }

      // Pointer drag on desktop (touch already scrolls natively).
      var down = false, startX = 0, startLeft = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        down = true; moved = false;
        startX = e.clientX;
        startLeft = track.scrollLeft;
        track.style.scrollBehavior = 'auto';
        track.style.scrollSnapType = 'none';
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 3) moved = true;
        track.scrollLeft = startLeft - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = false;
        track.style.scrollBehavior = '';
        track.style.scrollSnapType = '';
        if (moved) pause();
      });

      // Autoplay
      var timer = null;
      var ms = parseInt(root.dataset.autoplayMs, 10) || 5000;
      function start() {
        if (root.dataset.autoplay !== 'true' || timer) return;
        timer = window.setInterval(function () {
          if (document.hidden) return;
          go(1);
        }, ms);
      }
      function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
      function pause() { stop(); window.setTimeout(start, ms * 2); }

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      start();
    }

    function boot(scope) {
      (scope || document).querySelectorAll('[data-jyg-rvc]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(); });
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jyg-reviews-voice"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function photos(root) {
      var nodes = (root || document).querySelectorAll('[data-jygrv]');
      Array.prototype.forEach.call(nodes, function (el) {
        if (el.jygrvPhotos) return;
        el.jygrvPhotos = true;

        var lb = el.querySelector('[data-jygrv-lb]');
        var rp = el.querySelector('[data-jygrv-rp]');
        var set = [], at = 0, cap = '';

        function paint() {
          if (!lb) return;
          lb.querySelector('[data-jygrv-lbimg]').src = set[at];
          lb.querySelector('[data-jygrv-lbcount]').textContent = (at + 1) + ' / ' + set.length;
          lb.querySelector('[data-jygrv-lbcap]').textContent = cap;
          var nav = lb.querySelectorAll('.jygrv__lbnav');
          Array.prototype.forEach.call(nav, function (b) { b.style.display = set.length > 1 ? '' : 'none'; });
        }
        function openLb(item, i) {
          if (!lb) return;
          set = Array.prototype.map.call(item.querySelectorAll('[data-jygrv-pic]'), function (b) { return b.getAttribute('data-full'); });
          if (!set.length) return;
          at = Math.min(i, set.length - 1);
          cap = (item.getAttribute('data-rv-author') || '') + ' — ' + (item.getAttribute('data-rv-title') || '');
          paint(); lb.hidden = false;
        }
        function openRp(item) {
          if (!rp) return;
          var n = parseInt(item.getAttribute('data-rv-stars') || '5', 10);
          rp.querySelector('[data-jygrv-rpst]').textContent = '\u2605\u2605\u2605\u2605\u2605'.slice(0, n);
          rp.querySelector('[data-jygrv-rpt]').textContent = item.getAttribute('data-rv-title') || '';
          rp.querySelector('[data-jygrv-rpb]').textContent = item.getAttribute('data-rv-text') || '';
          var a = item.getAttribute('data-rv-author') || '';
          rp.querySelector('[data-jygrv-rpav]').textContent = a.slice(0, 1).toUpperCase();
          rp.querySelector('[data-jygrv-rpnm]').textContent = a;
          var okEl = item.querySelector('.jygrv__ok');
          rp.querySelector('[data-jygrv-rpok]').textContent = okEl ? okEl.textContent : '';
          var box = rp.querySelector('[data-jygrv-rppics]');
          box.innerHTML = '';
          Array.prototype.forEach.call(item.querySelectorAll('[data-jygrv-pic]'), function (b, i) {
            var c = document.createElement('button');
            c.type = 'button';
            c.innerHTML = b.innerHTML;
            c.addEventListener('click', function () { rp.hidden = true; openLb(item, i); });
            box.appendChild(c);
          });
          rp.hidden = false;
        }

        el.addEventListener('click', function (e) {
          var pic = e.target.closest ? e.target.closest('[data-jygrv-pic]') : null;
          var more = e.target.closest ? e.target.closest('[data-jygrv-more]') : null;
          var read = e.target.closest ? e.target.closest('[data-jygrv-read]') : null;
          var body = e.target.closest ? e.target.closest('[data-jygrv-body]') : null;
          var item = e.target.closest ? e.target.closest('[data-jygrv-item]') : null;
          if (!item) return;
          if (pic) {
            var all = Array.prototype.slice.call(item.querySelectorAll('[data-jygrv-pic]'));
            openLb(item, all.indexOf(pic));
          } else if (more) {
            openLb(item, 0);
          } else if (read) {
            openRp(item);
          } else if (body && item.classList.contains('is-cut')) {
            openRp(item);
          }
        });

        if (lb) {
          lb.addEventListener('click', function (e) { if (e.target === lb) lb.hidden = true; });
          lb.querySelector('[data-jygrv-lbclose]').addEventListener('click', function () { lb.hidden = true; });
          lb.querySelector('[data-jygrv-lbprev]').addEventListener('click', function () { at = (at - 1 + set.length) % set.length; paint(); });
          lb.querySelector('[data-jygrv-lbnext]').addEventListener('click', function () { at = (at + 1) % set.length; paint(); });
        }
        if (rp) {
          rp.addEventListener('click', function (e) { if (e.target === rp) rp.hidden = true; });
          rp.querySelector('[data-jygrv-rpclose]').addEventListener('click', function () { rp.hidden = true; });
        }
        document.addEventListener('keydown', function (e) {
          if (lb && !lb.hidden) {
            if (e.key === 'Escape') lb.hidden = true;
            if (e.key === 'ArrowRight') { at = (at + 1) % set.length; paint(); }
            if (e.key === 'ArrowLeft') { at = (at - 1 + set.length) % set.length; paint(); }
          } else if (rp && !rp.hidden && e.key === 'Escape') { rp.hidden = true; }
        });
      });
    }

    function wakeImages(el) {
      var thumbs = el.querySelectorAll('.jygrv__pic img[loading="lazy"]');
      if (!thumbs.length) return;
      function go() {
        Array.prototype.forEach.call(thumbs, function (im) {
          im.loading = 'eager';
          if (!im.complete || !im.naturalWidth) { var u = im.getAttribute('src'); im.setAttribute('src', u); }
        });
      }
      if (!('IntersectionObserver' in window)) { go(); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { go(); io.disconnect(); } });
      }, { rootMargin: '400px 0px' });
      io.observe(el);
    }

    function markCut(root) {
      var items = (root || document).querySelectorAll('[data-jygrv-item]');
      Array.prototype.forEach.call(items, function (it) {
        var b = it.querySelector('[data-jygrv-body]');
        if (!b) return;
        if (b.scrollHeight > b.clientHeight + 2) { it.classList.add('is-cut'); }
        else { it.classList.remove('is-cut'); }
      });
    }

    function boot(root) {
      var nodes = (root || document).querySelectorAll('[data-jygrv]');
      Array.prototype.forEach.call(nodes, function (el) {
        if (el.jygrvReady) return;
        el.jygrvReady = true;
        var track = el.querySelector('[data-jygrv-track]');
        if (!track) return;
        var bar = el.querySelector('[data-jygrv-bar]');
        var cnt = el.querySelector('[data-jygrv-count]');
        var prev = el.querySelector('[data-jygrv-prev]');
        var next = el.querySelector('[data-jygrv-next]');
        var total = track.children.length;
        function stepSize() {
          var first = track.children[0];
          if (!first) return 0;
          var cs = window.getComputedStyle(track);
          var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
          return first.getBoundingClientRect().width + gap;
        }
        function fades() {
          if (!el.hasAttribute('data-jygrv-fade')) return;
          var f = parseFloat(el.getAttribute('data-jygrv-fade') || '0');
          if (!f) return;
          var max = track.scrollWidth - track.clientWidth;
          var RUN = 70;
          var left = Math.min(f, f * (track.scrollLeft / RUN));
          var right = Math.min(f, f * ((max - track.scrollLeft) / RUN));
          if (max <= 2) { left = 0; right = 0; }
          track.style.setProperty('--rv-fl', Math.max(0, left).toFixed(2) + '%');
          track.style.setProperty('--rv-fr', Math.max(0, right).toFixed(2) + '%');
        }
        function ends() {
          fades();
          var max = track.scrollWidth - track.clientWidth;
          if (prev) { if (track.scrollLeft <= 2) { prev.setAttribute('disabled',''); } else { prev.removeAttribute('disabled'); } }
          if (next) { if (track.scrollLeft >= max - 2) { next.setAttribute('disabled',''); } else { next.removeAttribute('disabled'); } }
        }
        if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -stepSize(), behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { track.scrollBy({ left: stepSize(), behavior: 'smooth' }); });
        function update() {
          var max = track.scrollWidth - track.clientWidth;
          if (bar) {
            var w = Math.max(14, (track.clientWidth / track.scrollWidth) * 100);
            bar.style.width = w + '%';
            bar.style.left = max > 2 ? ((track.scrollLeft / max) * (100 - w)) + '%' : '0%';
          }
          if (cnt && total) {
            var per = track.scrollWidth / total;
            var i = Math.min(total, Math.floor(track.scrollLeft / per + 0.5) + 1);
            cnt.textContent = i + ' / ' + total;
          }
        }
        function refresh() { update(); ends(); }
        track.addEventListener('scroll', refresh, { passive: true });
        window.addEventListener('resize', refresh);

        function bleed() {
          if (!el.hasAttribute('data-jygrv-dcar')) return;
          var wrap = el.querySelector('.jygrv__wrap');
          var stage = el.querySelector('.jygrv__stage');
          if (!wrap || !stage) return;
          if (!window.matchMedia('(min-width: 750px)').matches) {
            stage.style.marginLeft = '';
            stage.style.marginRight = '';
            return;
          }
          var cs = window.getComputedStyle(wrap);
          var pad = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
          var content = wrap.getBoundingClientRect().width - pad;
          var extra = parseFloat(el.getAttribute('data-jygrv-bleed') || '0') || 0;
          var edge = parseFloat(el.getAttribute('data-jygrv-edge') || '40') || 0;
          var lane = 0;
          if (el.querySelector('.jygrv__arrow')) {
            lane = parseFloat(getComputedStyle(el).getPropertyValue('--rv-arrowlane')) || 56;
            lane = lane + 22;
          }
          var maxTrack = document.documentElement.clientWidth - ((edge + lane) * 2);
          var want = content + (extra * 2);
          var trackW = Math.min(want, maxTrack);
          if (trackW < content) trackW = content;
          var m = (trackW - content) / 2;
          stage.style.marginLeft = (-m) + 'px';
          stage.style.marginRight = (-m) + 'px';
        }
        function startPeek() {
          if (!el.hasAttribute('data-jygrv-dcar')) return;
          if (!window.matchMedia('(min-width: 750px)').matches) return;
          if (track.scrollWidth <= track.clientWidth + 4) return;
          var first = track.children[0];
          if (!first) return;
          var pk = parseFloat(el.getAttribute('data-jygrv-peek') || '50') / 100;
          var offset = first.getBoundingClientRect().width * pk;
          var max = track.scrollWidth - track.clientWidth;
          if (offset > 1) track.scrollLeft = Math.min(offset, max);
        }
        bleed();
        startPeek();
        refresh();
        window.setTimeout(function () { bleed(); startPeek(); refresh(); }, 280);
        window.addEventListener('resize', function () { bleed(); refresh(); });
      });
    }
    function start(root) {
      boot(root); photos(root); markCut(root);
      Array.prototype.forEach.call((root || document).querySelectorAll('[data-jygrv]'), wakeImages);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { start(document); });
    } else { start(document); }
    window.addEventListener('load', function () { markCut(document); });
    var mt;
    window.addEventListener('resize', function () { clearTimeout(mt); mt = setTimeout(function () { markCut(document); }, 120); });
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(function () { markCut(document); }); }
    document.addEventListener('shopify:section:load', function (e) { start(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jyg-spec-table"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-jyg-spec-table]');

    // Ordinal rankings so Power / Action columns sort light→heavy and slow→fast
    // instead of alphabetically. Accepts abbreviations and full words.
    var POWER_RANK = {
      ul: 1, ultralight: 1, ultralite: 1,
      l: 2, light: 2,
      ml: 3, mediumlight: 3, medlight: 3, mlight: 3,
      m: 4, medium: 4, med: 4,
      mh: 5, mediumheavy: 5, medheavy: 5, mheavy: 5,
      h: 6, heavy: 6,
      xh: 7, extraheavy: 7, xheavy: 7,
      xxh: 8, xxheavy: 8
    };
    var ACTION_RANK = {
      s: 1, slow: 1,
      ms: 2, moderateslow: 2, modslow: 2,
      mod: 3, moderate: 3, medium: 3, m: 3,
      mf: 4, moderatefast: 4, modfast: 4,
      f: 5, fast: 5,
      xf: 6, extrafast: 6, xfast: 6
    };

    function normToken(s) {
      return String(s).toLowerCase().replace(/[^a-z]/g, '');
    }

    function ordinalRank(raw, dict) {
      var key = normToken(raw);
      if (key === '') return -Infinity;
      if (dict[key] != null) return dict[key];
      return 999; // unknown tokens sort last (ascending)
    }

    function cartBaseUrl() {
      var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        ? window.Shopify.routes.root
        : '/';
      return r.replace(/\/$/, '');
    }

    function setCartCount(count) {
      if (count == null) return;
      var selectors = [
        '[data-cart-count]',
        '.cart-count-bubble span[aria-hidden="true"]',
        '.cart-count',
        '.js-cart-count',
        '#CartCount',
        '.site-header__cart-count span',
        '.cart-link__bubble-num'
      ];
      document.querySelectorAll(selectors.join(',')).forEach(function (el) {
        el.textContent = count;
        el.classList.remove('hidden', 'is-empty');
      });
    }

    function notifyThemeCartUpdated(cart) {
      var detail = { cart: cart, source: 'jyg-spec-table' };
      // Generic events various themes subscribe to.
      ['cart:refresh', 'cart:updated', 'cart:build', 'ajaxProduct:added'].forEach(function (name) {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
      });
    }

    var DRAWER_SELECTOR =
      'cart-drawer, #CartDrawer, .cart-drawer, #cart-drawer, [data-cart-drawer], #sidebar-cart, .drawer--cart';

    function getCartDrawer() {
      return document.querySelector(DRAWER_SELECTOR);
    }

    // The section id that wraps the cart drawer, for the Section Rendering API.
    function getDrawerSectionId() {
      var drawer = getCartDrawer();
      if (!drawer) return null;
      var section = drawer.closest('.shopify-section');
      if (section && section.id && section.id.indexOf('shopify-section-') === 0) {
        return section.id.slice('shopify-section-'.length);
      }
      return null;
    }

    // Swap the freshly-rendered drawer markup returned by /cart/add.js?sections=...
    function renderDrawerSection(html) {
      if (!html) return;
      var drawer = getCartDrawer();
      var section = drawer && drawer.closest('.shopify-section');
      try {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // The Section Rendering API returns the section's rendered template. Prefer
        // swapping just the drawer node when we can find a matching one in the response.
        var freshDrawer = doc.querySelector(DRAWER_SELECTOR);
        if (freshDrawer && drawer) {
          drawer.replaceWith(freshDrawer);
        } else if (section) {
          section.innerHTML = html;
        } else if (drawer) {
          drawer.innerHTML = html;
        }
      } catch (e) {
        if (section) section.innerHTML = html;
      }
    }

    // Impulse (Archetype Themes) — documented cart hooks:
    //   'cart:build' rebuilds the ajax drawer from the server,
    //   '.js-drawer-open-cart' / [aria-controls="CartDrawer"] opens it.
    function openImpulseCartDrawer() {
      var toggle = document.querySelector('.js-drawer-open-cart, [aria-controls="CartDrawer"]');
      var drawer = document.getElementById('CartDrawer');
      var hasImpulse = !!(toggle || drawer || (window.theme && window.theme.cart));
      if (!hasImpulse) return false;

      // Refresh the drawer contents (Impulse fetches /cart.js internally).
      document.dispatchEvent(new CustomEvent('cart:build'));

      // Open it.
      if (toggle) {
        toggle.click();
      } else if (drawer) {
        drawer.classList.add('is-open');
        document.documentElement.classList.add('js-drawer-open', 'js-drawer-open--right');
        document.body.classList.add('js-drawer-open');
      }
      return true;
    }

    function openCartDrawer() {
      // Theme-specific path first (this store runs Impulse 8.2).
      if (openImpulseCartDrawer()) return;

      // Generic fallback for other themes.
      var drawer = getCartDrawer();
      if (drawer) {
        if (typeof drawer.open === 'function') {
          try { drawer.open(); return; } catch (e) { /* fall through */ }
        }
        if (typeof drawer.show === 'function') {
          try { drawer.show(); return; } catch (e) { /* fall through */ }
        }
        drawer.removeAttribute('hidden');
        drawer.classList.add('active', 'is-open', 'open', 'drawer--is-open', 'js-active');
        document.body.classList.add('js-drawer-open', 'cart-drawer-open', 'drawer-open');
        document.documentElement.classList.add('js-drawer-open');
        return;
      }
      var toggle = document.querySelector(
        '#cart-icon-bubble, .header__icon--cart, [data-cart-toggle], [aria-controls*="cart" i]'
      );
      if (toggle) toggle.click();
    }

    // Once JS owns the submit, the native action is never used (preventDefault below),
    // so we blank it to stop Shop Promise / app scripts from latching onto these
    // per-row forms via form[action*="/cart/add"] selectors. If this script does not
    // load, the action attribute is untouched and the no-JS fallback still works.
    function shieldCartCell(cell) {
      function clean() {
        Array.prototype.slice.call(cell.querySelectorAll('*')).forEach(function (el) {
          var ours =
            el.tagName === 'FORM' ||
            el.tagName === 'INPUT' ||
            el.tagName === 'BUTTON' ||
            el.closest('button') ||
            el.classList.contains('jyg-spec-table__cart-soldout');
          if (!ours && !el.querySelector('form, button, input')) {
            if (el.parentNode) el.parentNode.removeChild(el);
          }
        });
      }
      clean();
      new MutationObserver(clean).observe(cell, { childList: true, subtree: true });
    }

    function bindCartForm(form) {
      form.setAttribute('action', '#');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var btn = form.querySelector('[data-jyg-cart-add]');
        var labelEl = form.querySelector('.jyg-spec-table__cart-label');
        var idInput = form.querySelector('input[name="id"]');
        if (!btn || !idInput || btn.disabled) return;

        var behavior = form.dataset.cartBehavior || 'none';
        var labelDefault = btn.dataset.labelDefault || '';
        var labelAdded = btn.dataset.labelAdded || '';

        var body = { items: [{ id: Number(idInput.value), quantity: 1 }] };
        var sectionId = behavior === 'drawer' ? getDrawerSectionId() : null;
        if (sectionId) {
          body.sections = sectionId;
          body.sections_url = window.location.pathname;
        }

        btn.disabled = true;
        btn.classList.remove('is-added', 'is-error');
        btn.classList.add('is-loading');

        fetch(cartBaseUrl() + '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) throw data;
              return data;
            });
          })
          .then(function (added) {
            // Refresh the drawer markup (if we requested it) before opening.
            if (behavior === 'drawer' && sectionId && added && added.sections) {
              renderDrawerSection(added.sections[sectionId]);
            }
            // Pull a fresh cart so we can update the count bubble.
            return fetch(cartBaseUrl() + '/cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.ok ? r.json() : null; })
              .catch(function () { return null; });
          })
          .then(function (cart) {
            btn.classList.remove('is-loading');
            btn.classList.add('is-added');
            if (labelEl && labelAdded) labelEl.textContent = labelAdded;

            setCartCount(cart ? cart.item_count : null);
            notifyThemeCartUpdated(cart);

            if (behavior === 'cart') {
              window.location.href = cartBaseUrl() + '/cart';
              return;
            }
            if (behavior === 'drawer') {
              openCartDrawer();
            }

            window.setTimeout(function () {
              btn.classList.remove('is-added');
              if (labelEl && labelDefault) labelEl.textContent = labelDefault;
              btn.disabled = false;
            }, 2200);
          })
          .catch(function (err) {
            btn.classList.remove('is-loading');
            btn.classList.add('is-error');
            btn.disabled = false;
            window.setTimeout(function () {
              btn.classList.remove('is-error');
            }, 2200);
            if (window.console) console.warn('[jyg-spec-table] add to cart failed', err);
          });
      });
    }

    roots.forEach(function (root) {
      var table = root.querySelector('[data-jyg-spec-table-el]');
      if (!table) return;

      root.classList.add('jyg-spec-table--js');

      var tbody = table.querySelector('tbody');
      var scrollWrapper = root.querySelector('.jyg-spec-table__scroll-wrapper');
      var scrollEl = root.querySelector('[data-jyg-spec-scroll]');
      var ths = table.querySelectorAll('th[data-sort-type]');
      var originalOrder = Array.prototype.slice.call(tbody.querySelectorAll('tr'));

      function parseValue(raw, sortType) {
        if (raw == null) return '';
        var str = String(raw).trim();
        if (str === '' || str === '—') return sortType === 'text' ? '' : -Infinity;

        switch (sortType) {
          case 'number':
            return parseFloat(str.replace(/[^0-9.\-]/g, '')) || 0;
          case 'weight': {
            // "12wt" → 12, "300g" → 300, "1/2oz" → 0.5
            if (str.indexOf('/') !== -1) {
              var fracMatch = str.match(/(\d+)\s*\/\s*(\d+)/);
              if (fracMatch) {
                return parseFloat(fracMatch[1]) / parseFloat(fracMatch[2]);
              }
            }
            var wMatch = str.match(/[\d.]+/);
            return wMatch ? parseFloat(wMatch[0]) : 0;
          }
          case 'length': {
            // "9'0\"" → 108 inches, "8'3\"" → 99
            var lMatch = str.match(/(\d+)\s*['′]\s*(\d+)?/);
            if (lMatch) {
              var feet = parseInt(lMatch[1], 10) || 0;
              var inches = parseInt(lMatch[2] || '0', 10);
              return feet * 12 + inches;
            }
            return parseFloat(str) || 0;
          }
          case 'price':
            return parseFloat(String(raw).replace(/[^0-9.\-]/g, '')) || 0;
          case 'power':
            return ordinalRank(str, POWER_RANK);
          case 'action':
            return ordinalRank(str, ACTION_RANK);
          case 'text':
          default:
            return str.toLowerCase();
        }
      }

      function sortBy(th) {
        var sortType = th.dataset.sortType;
        var colIndex = Array.prototype.indexOf.call(th.parentNode.children, th);
        var currentState = th.dataset.sortState;
        var nextState;

        if (currentState === 'none') nextState = 'asc';
        else if (currentState === 'asc') nextState = 'desc';
        else nextState = 'none';

        // Reset other columns
        ths.forEach(function (other) {
          if (other !== th) {
            other.dataset.sortState = 'none';
            other.setAttribute('aria-sort', 'none');
          }
        });

        th.dataset.sortState = nextState;
        th.setAttribute(
          'aria-sort',
          nextState === 'asc' ? 'ascending' : nextState === 'desc' ? 'descending' : 'none'
        );

        if (nextState === 'none') {
          originalOrder.forEach(function (row) {
            tbody.appendChild(row);
          });
          return;
        }

        var rows = Array.prototype.slice.call(tbody.querySelectorAll('tr'));
        rows.sort(function (a, b) {
          var aCell = a.children[colIndex];
          var bCell = b.children[colIndex];
          var aRaw = aCell ? (aCell.dataset.sortValue || aCell.textContent) : '';
          var bRaw = bCell ? (bCell.dataset.sortValue || bCell.textContent) : '';
          var aVal = parseValue(aRaw, sortType);
          var bVal = parseValue(bRaw, sortType);

          var cmp;
          if (typeof aVal === 'number' && typeof bVal === 'number') {
            cmp = aVal - bVal;
          } else {
            cmp = String(aVal).localeCompare(String(bVal));
          }
          return nextState === 'asc' ? cmp : -cmp;
        });

        rows.forEach(function (row) {
          tbody.appendChild(row);
        });
      }

      ths.forEach(function (th) {
        th.addEventListener('click', function () {
          sortBy(th);
        });
        th.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            sortBy(th);
          }
        });
      });

      // Add-to-cart forms (AJAX with no-JS form fallback)
      root.querySelectorAll('[data-jyg-cart-form]').forEach(bindCartForm);

      // Keep third-party injections (Shop Promise badges, upsell widgets) out of cart cells
      root.querySelectorAll('[data-jyg-cart-cell]').forEach(shieldCartCell);

      // Mobile sort chips reuse the same sort engine as the column headers.
      var mqMobile = window.matchMedia('(max-width: 749px)');
      var sortbar = root.querySelector('[data-jyg-sortbar]');
      var chips = sortbar
        ? Array.prototype.slice.call(sortbar.querySelectorAll('[data-jyg-sortchip]'))
        : [];

      function syncChips() {
        chips.forEach(function (chip, i) {
          var th = ths[i];
          var state = th ? th.dataset.sortState : 'none';
          chip.dataset.sortState = state;
          chip.classList.toggle('is-active', state !== 'none');
          chip.setAttribute('aria-pressed', state !== 'none' ? 'true' : 'false');
        });
      }

      chips.forEach(function (chip, i) {
        chip.addEventListener('click', function () {
          if (!ths[i]) return;
          sortBy(ths[i]);
          syncChips();
        });
      });

      // Row interaction: accordion toggle on mobile, navigate on desktop.
      // Clicks inside the cart cell are ignored so the button can do its job.
      // (The first cell is a real link, so no-JS / desktop still navigate.)
      tbody.querySelectorAll('tr[data-row-url]').forEach(function (tr) {
        tr.addEventListener('click', function (e) {
          if (e.target.closest('[data-jyg-cart-cell]')) return;
          if (mqMobile.matches) {
            e.preventDefault();
            var open = tr.classList.toggle('is-open');
            tr.setAttribute('aria-expanded', open ? 'true' : 'false');
            return;
          }
          if (e.target.closest('a')) return;
          window.location.href = tr.dataset.rowUrl;
        });
      });

      // Edge-fade visibility
      function updateScrollState() {
        if (!scrollEl || !scrollWrapper) return;
        var hasOverflow = scrollEl.scrollWidth > scrollEl.clientWidth + 1;
        var atEnd = scrollEl.scrollLeft + scrollEl.clientWidth >= scrollEl.scrollWidth - 1;
        scrollWrapper.classList.toggle('is-scrollable', hasOverflow);
        scrollWrapper.classList.toggle('is-scrolled-end', atEnd);
      }

      if (scrollEl) {
        updateScrollState();
        scrollEl.addEventListener('scroll', updateScrollState, { passive: true });
        window.addEventListener('resize', updateScrollState);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jyg-topbar"] && !Shopify.designMode) return;
  try {
    
  class JygTopbar {
    constructor(root) {
      this.root = root;
      this.mode = root.dataset.mode;
      this.pauseOnHover = root.dataset.pauseHover === 'true';
      this.hideArrowsMobile = root.dataset.hideArrowsMobile === 'true';
      this.slides = Array.from(root.querySelectorAll('[data-slide]'));
      this.dots = Array.from(root.querySelectorAll('[data-dot]'));
      this.prev = root.querySelector('[data-prev]');
      this.next = root.querySelector('[data-next]');
      this.track = root.querySelector('[data-track]');
      this.index = 0;
      this.timer = null;
      this.visible = true;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.mqMobile = window.matchMedia('(max-width: 749px)');

      this.bind();
      this.applyMode();
      if (this.mode === 'marquee') this.bindMarquee();
      this.watchVisibility();
      this.watchViewport();
    }

    // True when carousel should auto-rotate.
    // Auto mode → always. Manual mode → only on mobile when arrows are hidden there.
    shouldAutoRotate() {
      if (this.mode === 'auto') return true;
      if (this.mode === 'manual' && this.hideArrowsMobile && this.mqMobile.matches) return true;
      return false;
    }

    applyMode() {
      if (this.shouldAutoRotate()) this.startAuto();
      else this.stopAuto();
    }

    watchViewport() {
      const handler = () => this.applyMode();
      if (this.mqMobile.addEventListener) {
        this.mqMobile.addEventListener('change', handler);
      } else if (this.mqMobile.addListener) {
        this.mqMobile.addListener(handler);
      }
      this.mqHandler = handler;
    }

    bind() {
      if (this.prev) this.prev.addEventListener('click', () => this.go(this.index - 1, true));
      if (this.next) this.next.addEventListener('click', () => this.go(this.index + 1, true));
      this.dots.forEach((d) => d.addEventListener('click', () => this.go(parseInt(d.dataset.dot, 10), true)));

      if (this.pauseOnHover && this.mode !== 'manual') {
        this.root.addEventListener('mouseenter', () => this.pause());
        this.root.addEventListener('mouseleave', () => this.resume());
        this.root.addEventListener('focusin', () => this.pause());
        this.root.addEventListener('focusout', () => this.resume());
      }

      // Touch swipe for auto/manual
      if (this.mode !== 'marquee' && this.track) {
        let startX = 0;
        let dx = 0;
        this.track.addEventListener('touchstart', (e) => {
          startX = e.touches[0].clientX;
          dx = 0;
          this.pause();
        }, { passive: true });
        this.track.addEventListener('touchmove', (e) => {
          dx = e.touches[0].clientX - startX;
        }, { passive: true });
        this.track.addEventListener('touchend', () => {
          if (Math.abs(dx) > 40) {
            this.go(this.index + (dx < 0 ? 1 : -1), true);
          }
          this.resume();
        });
      }

      // Pause when tab hidden (battery)
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pause();
        else this.resume();
      });
    }

    watchVisibility() {
      if (!('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.visible = entry.isIntersecting;
          if (!this.visible) this.pause();
          else this.resume();
        });
      }, { threshold: 0 });
      io.observe(this.root);
      this.io = io;
    }

    go(targetIndex, userInitiated) {
      if (!this.slides.length) return;
      const n = this.slides.length;
      const i = ((targetIndex % n) + n) % n;
      this.slides[this.index].classList.remove('is-active');
      this.slides[this.index].setAttribute('aria-hidden', 'true');
      this.slides[i].classList.add('is-active');
      this.slides[i].removeAttribute('aria-hidden');
      this.dots.forEach((d, idx) => {
        const active = idx === i;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.index = i;
      if (userInitiated && this.shouldAutoRotate()) this.restartAuto();
    }

    startAuto() {
      if (this.reducedMotion) return;
      if (this.slides.length <= 1) return;
      const isMobile = this.mqMobile.matches;
      const cssVar = isMobile ? '--tb-auto-m' : '--tb-auto-d';
      const seconds = parseFloat(getComputedStyle(this.root).getPropertyValue(cssVar)) || 5;
      this.stopAuto();
      this.timer = setInterval(() => {
        if (this.visible && !document.hidden && !this.paused) {
          this.go(this.index + 1, false);
        }
      }, seconds * 1000);
    }

    stopAuto() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
    restartAuto() { if (this.shouldAutoRotate()) { this.stopAuto(); this.startAuto(); } }

    bindMarquee() {
      // pause_on_hover for marquee is handled via data-paused attr
      if (!this.pauseOnHover) return;
      const toggle = (state) => this.root.setAttribute('data-paused', state ? 'true' : 'false');
      this.root.addEventListener('mouseenter', () => toggle(true));
      this.root.addEventListener('mouseleave', () => toggle(false));
      this.root.addEventListener('focusin', () => toggle(true));
      this.root.addEventListener('focusout', () => toggle(false));
    }

    pause() {
      this.paused = true;
      if (this.mode === 'marquee') this.root.setAttribute('data-paused', 'true');
    }
    resume() {
      this.paused = false;
      if (this.mode === 'marquee' && this.pauseOnHover === false) this.root.setAttribute('data-paused', 'false');
      else if (this.mode === 'marquee') this.root.setAttribute('data-paused', 'false');
    }

    destroy() {
      this.stopAuto();
      if (this.io) this.io.disconnect();
      if (this.mqHandler) {
        if (this.mqMobile.removeEventListener) {
          this.mqMobile.removeEventListener('change', this.mqHandler);
        } else if (this.mqMobile.removeListener) {
          this.mqMobile.removeListener(this.mqHandler);
        }
      }
    }
  }

  const instances = new WeakMap();

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-jyg-topbar]').forEach((el) => {
      if (!instances.has(el)) instances.set(el, new JygTopbar(el));
    });
  }

  function destroyIn(scope) {
    (scope || document).querySelectorAll('[data-jyg-topbar]').forEach((el) => {
      const inst = instances.get(el);
      if (inst) { inst.destroy(); instances.delete(el); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  // Shopify editor lifecycle
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:section:unload', (e) => destroyIn(e.target));
  document.addEventListener('shopify:section:select', (e) => initAll(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const root = e.target.closest('[data-jyg-topbar]');
    if (!root) return;
    const inst = instances.get(root);
    const slide = e.target.closest('[data-slide]');
    if (inst && slide) inst.go(parseInt(slide.dataset.slide, 10), true);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jyg-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__jygVideoInit) return;
    window.__jygVideoInit = true;

    /* Auto-detect aspect ratio from any inline <video> when mode is "auto" */
    const applyAutoAspect = (videoEl, embedEl) => {
      if (!videoEl || !embedEl) return;
      if (embedEl.dataset.videoAspectMode !== 'auto') return;
      const set = () => {
        if (videoEl.videoWidth && videoEl.videoHeight) {
          /* Bubble the variables up to the section root so the height clamp works.
             Section root has the original --aspect-w / --aspect-h vars; we override them here. */
          const root = embedEl.closest('[class*="jyg-video-"]') || embedEl;
          root.style.setProperty('--video-aspect', videoEl.videoWidth + '/' + videoEl.videoHeight);
          root.style.setProperty('--aspect-w', videoEl.videoWidth);
          root.style.setProperty('--aspect-h', videoEl.videoHeight);
        }
      };
      if (videoEl.readyState >= 1) set();
      else videoEl.addEventListener('loadedmetadata', set, { once: true });
    };

    /* Build a player element from a button's data attributes */
    const buildPlayer = (btn, opts) => {
      opts = opts || {};
      const videoFile = btn.dataset.videoFile;
      const videoSourcesRaw = btn.dataset.videoSources;
      const videoUrl = btn.dataset.videoUrl;
      const autoplayUrl = videoUrl
        ? (videoUrl.includes('?') ? `${videoUrl}&autoplay=1` : `${videoUrl}?autoplay=1`)
        : null;

      let videoSources = null;
      if (videoSourcesRaw) {
        try { videoSources = JSON.parse(videoSourcesRaw); } catch (err) { console.warn('JYG Video: bad sources JSON', err); }
      }

      const muted = !!opts.muted;
      let player;

      if (videoSources && videoSources.length) {
        player = document.createElement('video');
        player.controls = true;
        player.autoplay = true;
        player.playsInline = true;
        player.muted = muted;
        player.preload = 'auto';
        videoSources.forEach((s) => {
          const src = document.createElement('source');
          src.src = s.src;
          if (s.type) src.type = s.type;
          player.appendChild(src);
        });
      } else if (videoFile) {
        player = document.createElement('video');
        player.src = videoFile;
        player.controls = true;
        player.autoplay = true;
        player.playsInline = true;
        player.muted = muted;
        player.preload = 'metadata';
      } else if (autoplayUrl) {
        player = document.createElement('iframe');
        player.src = autoplayUrl;
        player.setAttribute('frameborder', '0');
        player.setAttribute('allow', 'autoplay; encrypted-media');
        player.setAttribute('allowfullscreen', 'true');
        player.loading = 'lazy';
      }

      return player;
    };

    /* Modal helpers */
    let activeModalSection = null;

    const closeAnyModal = () => {
      document.querySelectorAll('[data-jyg-modal].is-open').forEach((m) => {
        m.classList.remove('is-open');
        m.setAttribute('aria-hidden', 'true');
        const stage = m.querySelector('[data-jyg-modal-stage]');
        if (stage) stage.innerHTML = '';
      });
      document.body.classList.remove('jyg-video-modal-open');
      activeModalSection = null;
    };

    const openModal = (sectionRoot, btn) => {
      const modal = sectionRoot.querySelector('[data-jyg-modal]');
      const stage = modal && modal.querySelector('[data-jyg-modal-stage]');
      if (!modal || !stage) return false;

      const player = buildPlayer(btn, { muted: false });
      if (!player) return false;

      stage.innerHTML = '';
      /* Inline styles so the player fills the stage cleanly */
      player.style.maxWidth = '100%';
      player.style.maxHeight = '100%';
      stage.appendChild(player);

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('jyg-video-modal-open');
      activeModalSection = sectionRoot;

      setTimeout(() => {
        try { player.play && player.play(); } catch (err) {}
      }, 60);

      return true;
    };

    const wireUpAction = (btn) => {
      if (btn.__jygWired) return;
      btn.__jygWired = true;

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const embed = btn.closest('.jyg-video__embed');
        const sectionRoot = btn.closest('[class*="jyg-video-"]') || document;

        /* Modal mode? */
        if (embed && embed.dataset.modalMode === '1') {
          if (openModal(sectionRoot, btn)) return;
        }

        /* Fallback: inline replace */
        const parent = embed || btn.parentElement;
        if (!parent) return;

        const player = buildPlayer(btn, { muted: false });
        if (!player) return;

        player.style.position = 'absolute';
        player.style.inset = '0';
        player.style.width = '100%';
        player.style.height = '100%';
        player.style.objectFit = 'contain';

        applyAutoAspect(player, parent);

        parent.innerHTML = '';
        parent.appendChild(player);
        try { player.play && player.play(); } catch (err) {}
        player.focus?.();
      });
    };

    /* Modal close wiring */
    const wireUpModal = (modal) => {
      if (modal.__jygWired) return;
      modal.__jygWired = true;

      const closeBtn = modal.querySelector('[data-jyg-modal-close]');
      if (closeBtn) closeBtn.addEventListener('click', closeAnyModal);

      modal.addEventListener('click', (e) => {
        /* Click on backdrop (modal itself, not its children) */
        if (e.target === modal) closeAnyModal();
      });
    };

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && activeModalSection) closeAnyModal();
    });

    const init = (root) => {
      const scope = root || document;
      scope.querySelectorAll('[data-video-autoaspect]').forEach((v) => {
        applyAutoAspect(v, v.closest('.jyg-video__embed'));
      });
      scope.querySelectorAll('[data-video-action]').forEach(wireUpAction);
      scope.querySelectorAll('[data-jyg-modal]').forEach(wireUpModal);
    };

    init(document);

    /* Re-init when Theme Editor reloads a section */
    document.addEventListener('shopify:section:load', (e) => {
      if (e.target) init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-text"] && !Shopify.designMode) return;
  try {
    
  // Lightweight: pause when section off-screen or tab hidden. CSS handles hover.
  (function () {
    const init = (root) => {
      if (root.dataset.jygMarqueeInit === '1') return;
      root.dataset.jygMarqueeInit = '1';

      let offScreen = false;
      let tabHidden = false;
      const apply = () => {
        root.dataset.paused = (offScreen || tabHidden) ? 'true' : 'false';
      };

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => { offScreen = !e.isIntersecting; apply(); });
        }, { threshold: 0 });
        io.observe(root);
        root._jygMarqIo = io;
      }

      const visHandler = () => { tabHidden = document.hidden; apply(); };
      document.addEventListener('visibilitychange', visHandler);
      root._jygMarqVis = visHandler;
    };

    const initAll = (scope) => {
      (scope || document).querySelectorAll('[data-jyg-marquee]').forEach(init);
    };

    const teardown = (scope) => {
      (scope || document).querySelectorAll('[data-jyg-marquee]').forEach((root) => {
        if (root._jygMarqIo) { root._jygMarqIo.disconnect(); delete root._jygMarqIo; }
        if (root._jygMarqVis) {
          document.removeEventListener('visibilitychange', root._jygMarqVis);
          delete root._jygMarqVis;
        }
        delete root.dataset.jygMarqueeInit;
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load',   (e) => initAll(e.target));
    document.addEventListener('shopify:section:unload', (e) => teardown(e.target));
    document.addEventListener('shopify:section:select', (e) => initAll(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shore-pro-bento"] && !Shopify.designMode) return;
  try {
    
  // Bento behaviour:
  //   1. Pause native videos when off-screen (battery, mobile data).
  //   2. Optional auto-center: when a row's spans sum to less than the column
  //      count, center the row by setting `grid-column: <offset> / span <n>`
  //      on its first card.
  (function () {
    // --- AUTO-CENTER INCOMPLETE ROWS ---------------------------------------
    // Linear walk that sums column spans to figure out which cards land in
    // which row, then centers any row whose total span is < column count.
    //
    // Skipped when any card has row-span > 1: a 1D sum can't replicate CSS
    // Grid's 2D dense packing, so explicit column offsets would overlap the
    // row-spanning card.
    const centerRows = (root) => {
      const grid = root.querySelector('.jyg-bento__grid');
      if (!grid) return;
      const cards = Array.from(grid.children).filter((c) =>
        c.classList && c.classList.contains('jyg-bento__card')
      );
      if (!cards.length) return;

      // Reset previous placements before recomputing (toggling off or resizes
      // across breakpoints would otherwise leave stale grid-column values).
      cards.forEach((c) => {
        c.style.gridColumn = '';
        c.style.gridColumnStart = '';
      });

      if (root.dataset.autoCenter !== 'true') return;

      // Resolve the active breakpoint to one set of CSS variable names.
      const bp = (() => {
        if (window.matchMedia('(max-width: 749px)').matches) {
          return { spanVar: '--span-m', rowVar: '--row-m', colsVar: '--bn-cols-m', fallbackSpan: 12 };
        }
        if (window.matchMedia('(max-width: 1024px)').matches) {
          return { spanVar: '--span-t', rowVar: '--row-d', colsVar: '--bn-cols-t', fallbackSpan: 6 };
        }
        return { spanVar: '--span-d', rowVar: '--row-d', colsVar: '--bn-cols-d', fallbackSpan: 6 };
      })();

      const hasRowSpan = cards.some((c) => {
        const r = parseInt(c.style.getPropertyValue(bp.rowVar), 10) || 1;
        return r > 1;
      });
      if (hasRowSpan) return;

      const cols = parseInt(getComputedStyle(root).getPropertyValue(bp.colsVar), 10) || 12;

      // rowFirstSpan is tracked so closeRow() can emit the full
      // `<start> / span <span>` shorthand — unambiguous placement that CSS
      // Grid won't try to re-flow elsewhere.
      let rowSum = 0;
      let rowStart = 0;
      let rowFirstSpan = 0;
      const closeRow = (endIndex) => {
        if (rowSum > 0 && rowSum < cols && rowStart <= endIndex) {
          const offset = Math.floor((cols - rowSum) / 2) + 1;
          if (offset > 1) {
            cards[rowStart].style.gridColumn = offset + ' / span ' + rowFirstSpan;
          }
        }
      };

      for (let i = 0; i < cards.length; i++) {
        const raw = cards[i].style.getPropertyValue(bp.spanVar).trim();
        const span = Math.min(cols, parseInt(raw, 10) || bp.fallbackSpan);
        if (rowSum + span > cols) {
          closeRow(i - 1);
          rowSum = span;
          rowStart = i;
          rowFirstSpan = span;
        } else {
          if (rowSum === 0) {
            rowStart = i;
            rowFirstSpan = span;
          }
          rowSum += span;
        }
      }
      closeRow(cards.length - 1);
    };

    // --- VIDEO PAUSE-ON-VIEWPORT ------------------------------------------
    const initVideos = (root) => {
      const videos = root.querySelectorAll('video.jyg-bento__video');
      if (!videos.length || !('IntersectionObserver' in window)) return null;
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          const v = e.target;
          if (e.isIntersecting && v.autoplay && v.paused) {
            const p = v.play();
            if (p && typeof p.catch === 'function') p.catch(() => {});
          } else if (!e.isIntersecting && !v.paused) {
            v.pause();
          }
        });
      }, { threshold: 0.1 });
      videos.forEach((v) => io.observe(v));
      return io;
    };

    // --- LIFECYCLE --------------------------------------------------------
    const debounce = (fn, ms) => {
      let t;
      return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); };
    };

    const init = (root) => {
      if (root.dataset.jygBentoInit === '1') return;
      root.dataset.jygBentoInit = '1';

      root._jygBentoIo = initVideos(root);
      requestAnimationFrame(() => centerRows(root));

      const onResize = debounce(() => centerRows(root), 150);
      window.addEventListener('resize', onResize);
      root._jygBentoResize = onResize;
    };

    const initAll = (scope) => {
      (scope || document).querySelectorAll('[data-jyg-bento]').forEach(init);
    };
    const teardown = (scope) => {
      (scope || document).querySelectorAll('[data-jyg-bento]').forEach((root) => {
        if (root._jygBentoIo) { root._jygBentoIo.disconnect(); delete root._jygBentoIo; }
        if (root._jygBentoResize) {
          window.removeEventListener('resize', root._jygBentoResize);
          delete root._jygBentoResize;
        }
        delete root.dataset.jygBentoInit;
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load',   (e) => initAll(e.target));
    document.addEventListener('shopify:section:unload', (e) => teardown(e.target));
    document.addEventListener('shopify:section:select', (e) => initAll(e.target));
    document.addEventListener('shopify:block:added',    (e) => {
      const root = e.target.closest && e.target.closest('[data-jyg-bento]');
      if (root) requestAnimationFrame(() => centerRows(root));
    });
    document.addEventListener('shopify:block:removed',  () => {
      document.querySelectorAll('[data-jyg-bento]').forEach((root) => {
        requestAnimationFrame(() => centerRows(root));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
